import { render, staticRenderFns } from "./EmployeesTab.vue?vue&type=template&id=2a7ebe6a"
import script from "./EmployeesTab.vue?vue&type=script&lang=js"
export * from "./EmployeesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports